// extracted by mini-css-extract-plugin
export default {"container":"not-found_container__dFUwH","errorCode":"not-found_errorCode__vbmXZ","message":"not-found_message__m-iz-","homeLink":"not-found_homeLink__4ztpH"};